import VSelectCourse from './index.vue';

export default {
  install: (Vue) => Vue.component('VSelectCourse', VSelectCourse),
};
